// extracted by mini-css-extract-plugin
export default {"bottomModal":"menuDetail_bottomModal__HAgRL","modal-dialog":"menuDetail_modal-dialog__dGPx5"};